/* js/components/CardPlayer.svelte generated by Svelte v3.46.4 */
import {
	HtmlTag,
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	outro_and_destroy_block,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import TrackPlayer from "./TrackPlayer.svelte";
import CardMeta from "./CardMeta.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

// (9:4) {#if currentCardIndex == card.cardIndex}
function create_if_block(ctx) {
	let div;
	let cardmeta;
	let t0;
	let trackplayer;
	let t1;
	let html_tag;
	let raw_value = /*card*/ ctx[2].html + "";
	let t2;
	let current;
	cardmeta = new CardMeta({ props: { card: /*card*/ ctx[2] } });

	trackplayer = new TrackPlayer({
			props: {
				src: /*card*/ ctx[2].media.src,
				type: /*card*/ ctx[2].media.type
			}
		});

	return {
		c() {
			div = element("div");
			create_component(cardmeta.$$.fragment);
			t0 = space();
			create_component(trackplayer.$$.fragment);
			t1 = space();
			html_tag = new HtmlTag();
			t2 = space();
			html_tag.a = t2;
			attr(div, "class", "card");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(cardmeta, div, null);
			append(div, t0);
			mount_component(trackplayer, div, null);
			append(div, t1);
			html_tag.m(raw_value, div);
			append(div, t2);
			current = true;
		},
		p(ctx, dirty) {
			const cardmeta_changes = {};
			if (dirty & /*cards*/ 1) cardmeta_changes.card = /*card*/ ctx[2];
			cardmeta.$set(cardmeta_changes);
			const trackplayer_changes = {};
			if (dirty & /*cards*/ 1) trackplayer_changes.src = /*card*/ ctx[2].media.src;
			if (dirty & /*cards*/ 1) trackplayer_changes.type = /*card*/ ctx[2].media.type;
			trackplayer.$set(trackplayer_changes);
			if ((!current || dirty & /*cards*/ 1) && raw_value !== (raw_value = /*card*/ ctx[2].html + "")) html_tag.p(raw_value);
		},
		i(local) {
			if (current) return;
			transition_in(cardmeta.$$.fragment, local);
			transition_in(trackplayer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cardmeta.$$.fragment, local);
			transition_out(trackplayer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(cardmeta);
			destroy_component(trackplayer);
		}
	};
}

// (8:0) {#each cards as card (card.cardIndex)}
function create_each_block(key_1, ctx) {
	let first;
	let if_block_anchor;
	let current;
	let if_block = /*currentCardIndex*/ ctx[1] == /*card*/ ctx[2].cardIndex && create_if_block(ctx);

	return {
		key: key_1,
		first: null,
		c() {
			first = empty();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.first = first;
		},
		m(target, anchor) {
			insert(target, first, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;

			if (/*currentCardIndex*/ ctx[1] == /*card*/ ctx[2].cardIndex) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*currentCardIndex, cards*/ 3) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(first);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function create_fragment(ctx) {
	let each_blocks = [];
	let each_1_lookup = new Map();
	let each_1_anchor;
	let current;
	let each_value = /*cards*/ ctx[0];
	const get_key = ctx => /*card*/ ctx[2].cardIndex;

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (dirty & /*cards, currentCardIndex*/ 3) {
				each_value = /*cards*/ ctx[0];
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, each_1_anchor.parentNode, outro_and_destroy_block, create_each_block, each_1_anchor, get_each_context);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d(detaching);
			}

			if (detaching) detach(each_1_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { cards = [] } = $$props;
	let { currentCardIndex = 0 } = $$props;

	$$self.$$set = $$props => {
		if ('cards' in $$props) $$invalidate(0, cards = $$props.cards);
		if ('currentCardIndex' in $$props) $$invalidate(1, currentCardIndex = $$props.currentCardIndex);
	};

	return [cards, currentCardIndex];
}

class CardPlayer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { cards: 0, currentCardIndex: 1 });
	}
}

export default CardPlayer;